var map = {
	"./index.js": 85,
	"./messages.js": 313,
	"./notifications.js": 314,
	"./products.js": 315,
	"./tasks.js": 316,
	"./user.js": 317
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 883;


//////////////////
// WEBPACK FOOTER
// ./src/vuex/modules nonrecursive \.js$
// module id = 883
// module chunks = 0